import { ButtonRounded } from 'is24-corecss';
import React, { useCallback } from 'react';
import { css } from '@emotion/css';

import PeopleSVG from './PeopleSVG';
import { ValentinesUpsellModal } from './ValentinesUpsellModal';
import { VALENTINES_UPSELL_PARAM } from './constants';
import { useIntl } from '@/i18n/hooks/useIntl';
import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { Feature } from '@/@types/featureSwitch';

const styles = {
  whiteButton: css`
    background-color: white !important;
  `,
  content: css`
    gap: 0 !important;
  `,
};

export const ValentinesUpsellBanner = () => {
  const { t } = useIntl();
  const isFeatureEnabled = useFeature(Feature.VALENTINE_SPECIAL_MODAL);

  const handleOpenModal = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.set(VALENTINES_UPSELL_PARAM, 'true');
    window.history.pushState({}, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }, []);

  const handleCloseModal = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete(VALENTINES_UPSELL_PARAM);
    window.history.pushState({}, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }, []);

  if (!isFeatureEnabled) {
    return null;
  }

  return (
    <>
      <div className='notification notification--neutral notification--flat'>
        <div className='notification__icon'>
          <PeopleSVG />
        </div>
        <div className={`notification__content ${styles.content}`}>
          <div className='notification__title'>{t({ id: 'valentinesUpsellBanner.title' })}</div>
          <div className='notification__message'>{t({ id: 'valentinesUpsellBanner.message' })}</div>
          <div className='notification__actions'>
            <ButtonRounded
              variant='outlineWeak'
              size='small'
              onClick={handleOpenModal}
              label={t({ id: 'valentinesUpsellBanner.cta' })}
              className={`margin-top-m ${styles.whiteButton}`}
            />
          </div>
        </div>
      </div>
      <ValentinesUpsellModal onClose={handleCloseModal} />
    </>
  );
};
